import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './transferenciaForm';
import FormatUtils from '../common/formatUtils/FormatUtils';
import Aguardando from '../common/template/aguardando';
import pdfAdd from '../assets/images/icone_add_pdf.png';

import { 
	alterarCargaBase, alterarDescargaBase
} from './transferenciaActions';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import consts from '../consts';
import Camera from '../common/camera/camera';
import { setError } from '../common/toast/toast';

class TransferenciaBaseVisualizacao extends Component {

	state = {
		linhaSelecionada: null,
		scrollY: -1
	}

    componentWillMount() {
	
    }

    render() {

		const registro = this.props.registro;

        return (
            <div>
                <Content>
					
					<Aguardando aguardando={this.props.aguardando} />

					{this.eventoComponenteNumerico()}

					<ContentCard key={registro.id} style={{ backgroundColor: '#ffffff' }}>
						<ContentCardHeader>
							<Row>
								<Grid cols='12 12 12 12'>
									<strong>Base:</strong> {registro.nome_unidade}
								</Grid>
								<Grid cols='12 12 12 12'>
									<strong>Distribuidora:</strong> {registro.nome_distribuidora}
								</Grid>
								<Grid cols='12 12 12 12'>
									<strong>Placa:</strong> {registro.placa_veiculo}
								</Grid>
								<Grid cols='12 12 12 12'>
									<strong>Motorista:</strong> {registro.nome_motorista}
								</Grid>
								<Grid cols='12 12 12 12'>
									<strong>Nota Fiscal:</strong> {registro.numero_nfe}
								</Grid>
								{registro.datahora_inicio_carga &&
								<Grid cols='12 12 12 12'>
									<strong>Início da Carga:</strong> {DateFormat.formatarDataHoraSqlParaTela(registro.datahora_inicio_carga)}
								</Grid>}
								{registro.datahora_fim_carga &&
								<Grid cols='12 12 12 12'>
									<strong>Fim da Carga:</strong> {DateFormat.formatarDataHoraSqlParaTela(registro.datahora_fim_carga)}
								</Grid>}
								{registro.datahora_inicio_descarga &&
								<Grid cols='12 12 12 12'>
									<strong>Início da Descarga:</strong> {DateFormat.formatarDataHoraSqlParaTela(registro.datahora_inicio_descarga)}
								</Grid>}
								{registro.datahora_fim_descarga &&
								<Grid cols='12 12 12 12'>
									<strong>Fim da Descarga:</strong> {DateFormat.formatarDataHoraSqlParaTela(registro.datahora_fim_descarga)}
								</Grid>}
								<Grid cols='12 12 12 12'>
									<strong>Itens:</strong>
								</Grid>
							</Row>

							{(registro.itens || []).filter(transferenciaItem => transferenciaItem.ativo).map((transferenciaItem, i) => (
								<Row key={transferenciaItem.id} style={{ backgroundColor: i % 2 == 0 ? '#f2f5f3' : '#e0e0e0' }}>
									<Grid cols='6 6 6 6'>
										{transferenciaItem.nome_produto}
									</Grid>
									<Grid cols='6 6 6 6' style={{ textAlign: 'right' }}>
										{FormatUtils.formatarValorTelaDecimal(transferenciaItem.quantidade, 2)} L
									</Grid>
								</Row>
							))}

							{registro.datahora_inicio_carga &&
							<>
								<Row>
									<h4 style={{ padding: 8 }}>Carregamento</h4>
								</Row>
								<Row>
									{this.componenteImagem(
										'Foto da Frente:',
										registro.carga_imagem_frente || [],
										(arquivos) => {
											this.props.alterarCargaBase({
												...registro,
												carga_imagem_frente: arquivos
											});
										}
									)}
								</Row>

								<Row>
									{this.componenteImagem(
										'Foto do Calço:',
										registro.carga_imagem_calco || [],
										(arquivos) => {
											this.props.alterarCargaBase({
												...registro,
												carga_imagem_calco: arquivos
											});
										}
									)}
								</Row>
										
								<Row>
									{this.componenteImagem(
										'Foto do Aterramento:',
										registro.carga_imagem_terra || [],
										(arquivos) => {
											this.props.alterarCargaBase({
												...registro,
												carga_imagem_terra: arquivos
											});
										}
									)}
								</Row>
										
								<Row>
									{this.componenteImagem(
										'Foto da Nota Fiscal:',
										registro.carga_imagem_nf || [],
										(arquivos) => {
											this.props.alterarCargaBase({
												...registro,
												carga_imagem_nf: arquivos
											});
										}
									)}
								</Row>
																		
								<Row>
									{this.componenteImagem(
										'Foto do Lacre:',
										registro.carga_imagem_lacre || [],
										(arquivos) => {
											this.props.alterarCargaBase({
												...registro,
												carga_imagem_lacre: arquivos
											});
										}
									)}
								</Row>
										
								<Row>
									{this.componenteImagem(
										'Foto do Dreno:',
										registro.carga_imagem_dreno || [],
										(arquivos) => {
											this.props.alterarCargaBase({
												...registro,
												carga_imagem_dreno: arquivos
											});
										}
									)}
								</Row>
										
								<Row>
									{this.componenteImagem(
										'Foto da Seta:',
										registro.carga_imagem_seta || [],
										(arquivos) => {
											this.props.alterarCargaBase({
												...registro,
												carga_imagem_seta: arquivos
											});
										}
									)}
								</Row>

								<Row>
									{this.componenteNumerico(
										`Temperatura:`,
										(registro.carga_temperatura || [])[0],
										1 //Casas Decimais
									)}
								</Row>

								{(this.props.usuarioCarregado && (this.props.usuarioCarregado.acesso_logistica)) ? (
									<Row>
										{this.componenteNumericoAlteracao(
											`Quantidade S10:`,
											(registro.carga_quantidade_s10 || [])[0],
											(valor) => {
												this.props.alterarCargaBase({
													...registro,
													carga_quantidade_s10: [{
														valor: valor
													}]
												});

												setTimeout(() => {
													this.props.eventoAtualizacao();
												}, 2000);
											},
											0 //Casas Decimais
										)}
									
										{this.componenteNumericoAlteracao(
											`Quantidade S500:`,
											(registro.carga_quantidade_s500 || [])[0],
											(valor) => {
												this.props.alterarCargaBase({
													...registro,
													carga_quantidade_s500: [{
														valor: valor
													}]
												});

												setTimeout(() => {
													this.props.eventoAtualizacao();
												}, 2000);
											},
											0 //Casas Decimais
										)}
									</Row>
								) : (
									<>
										<Row>
											{this.componenteNumerico(
												`Quantidade S10:`,
												(registro.carga_quantidade_s10 || [])[0],
												0 //Casas Decimais
											)}
										</Row>

										<Row>
											{this.componenteNumerico(
												`Quantidade S500:`,
												(registro.carga_quantidade_s500 || [])[0],
												0 //Casas Decimais
											)}
										</Row>
									</>
								)}
							</>}

							{registro.datahora_inicio_descarga &&
							<>
								<Row>
									<h4 style={{ padding: 8 }}>Descarga</h4>
								</Row>
								<Row>
									{this.componenteImagem(
										'Foto da Frente:',
										registro.descarga_imagem_frente || [],
										(arquivos) => {
											this.props.alterarDescargaBase({
												...registro,
												descarga_imagem_frente: arquivos
											});
										}
									)}
								</Row>

								<Row>
									{this.componenteImagem(
										'Foto do Calço:',
										registro.descarga_imagem_calco || [],
										(arquivos) => {
											this.props.alterarDescargaBase({
												...registro,
												descarga_imagem_calco: arquivos
											});
										}
									)}
								</Row>
										
								<Row>
									{this.componenteImagem(
										'Foto do Aterramento:',
										registro.descarga_imagem_terra || [],
										(arquivos) => {
											this.props.alterarDescargaBase({
												...registro,
												descarga_imagem_terra: arquivos
											});
										}
									)}
								</Row>
										
								<Row>
									{this.componenteImagem(
										'Foto da Nota Fiscal:',
										registro.descarga_imagem_nf || [],
										(arquivos) => {
											this.props.alterarDescargaBase({
												...registro,
												descarga_imagem_nf: arquivos
											});
										}
									)}
								</Row>
										
								<Row>
									{this.componenteImagem(
										'Foto da Proveta:',
										registro.descarga_imagem_proveta || [],
										(arquivos) => {
											this.props.alterarDescargaBase({
												...registro,
												descarga_imagem_proveta: arquivos
											});
										}
									)}
								</Row>
										
								<Row>
									{this.componenteImagem(
										'Foto do Lacre:',
										registro.descarga_imagem_lacre || [],
										(arquivos) => {
											this.props.alterarDescargaBase({
												...registro,
												descarga_imagem_lacre: arquivos
											});
										}
									)}
								</Row>
										
								<Row>
									{this.componenteImagem(
										'Foto do Dreno:',
										registro.descarga_imagem_dreno || [],
										(arquivos) => {
											this.props.alterarDescargaBase({
												...registro,
												descarga_imagem_dreno: arquivos
											});
										}
									)}
								</Row>
										
								<Row>
									{this.componenteImagem(
										'Foto da Seta:',
										registro.descarga_imagem_seta || [],
										(arquivos) => {
											this.props.alterarDescargaBase({
												...registro,
												descarga_imagem_seta: arquivos
											});
										}
									)}
								</Row>

								<Row>
									{this.componenteImagem(
										'Foto Proveta / Densidade / Temperatura:',
										registro.descarga_imagem_qualidade || [],
										(arquivos) => {
											this.props.alterarDescargaBase({
												...registro,
												descarga_imagem_qualidade: arquivos
											});
										}
									)}
								</Row>
								<Row>
									{this.componenteNumerico(
										`Temperatura:`,
										(registro.descarga_temperatura || [])[0],
										1 //Casas Decimais
									)}
								</Row>
								
								<Row>
									{this.componenteNumerico(
										`Densidade:`,
										(registro.descarga_densidade || [])[0],
										2 //Casas Decimais
									)}
								</Row>

								{/* Janiel, Pedro, Artur Gonçalves Rodrigues */}
								{(this.props.sessao && ([1, 4, 74].includes(this.props.sessao.id))) ? (
									<Row>
										{this.componenteNumericoAlteracao(
											`Quantidade S10:`,
											(registro.descarga_quantidade_s10 || [])[0],
											(valor) => {
												this.props.alterarDescargaBase({
													...registro,
													descarga_quantidade_s10: [{
														valor: valor
													}]
												});

												setTimeout(() => {
													this.props.eventoAtualizacao();
												}, 2000);
											},
											0 //Casas Decimais
										)}
									
										{this.componenteNumericoAlteracao(
											`Quantidade S500:`,
											(registro.descarga_quantidade_s500 || [])[0],
											(valor) => {
												this.props.alterarDescargaBase({
													...registro,
													descarga_quantidade_s500: [{
														valor: valor
													}]
												});

												setTimeout(() => {
													this.props.eventoAtualizacao();
												}, 2000);
											},
											0 //Casas Decimais
										)}
									</Row>
								) : (
									<>
										<Row>
											{this.componenteNumerico(
												`Quantidade S10:`,
												(registro.descarga_quantidade_s10 || [])[0],
												0 //Casas Decimais
											)}
										</Row>

										<Row>
											{this.componenteNumerico(
												`Quantidade S500:`,
												(registro.descarga_quantidade_s500 || [])[0],
												0 //Casas Decimais
											)}
										</Row>
									</>
								)}
							</>}
						</ContentCardHeader>
					</ContentCard>
                </Content>
            </div>
        )
    }

	componenteImagem(nome, arquivos, evento) {

		return (
			<Grid cols='12 12 12 12'>
				<Row style={{ paddingBottom: 8 }}>
					<Grid cols='12 12 12 12'>
						<label>{nome} <i class={(arquivos || []).length ? `fas fa-check-double` : 'fas fa-exclamation-triangle'} style={{ color: (arquivos || []).length ? '#00a13b' : '#ff0000' }}></i></label>
					</Grid>
					{(arquivos || []).map(arquivo => (
						<div key={arquivo.id} style={{ marginLeft: 8, display: 'flex', flexDirection: 'column' }}>
							<span class="btn btn-outline-primary fileinput-button dz-clickable"
								onClick={() => {
									window.open(`${consts.URL}/${arquivo.file}`, '_blank');
								}}>
								<img src={arquivo.arquivo_base64 ? arquivo.arquivo_base64 : (arquivo.file ? `${consts.URL}/${arquivo.file}` : pdfAdd)} style={{ height: 400 }} />
							</span>
						</div>
					))}						
				</Row>
			</Grid>
		);
	}

	componenteNumerico(nome, registro, casasDecimais) {

		return (
			<Grid cols='12 12 12 12'>
				<Row style={{ paddingBottom: 8 }}>
					<Grid cols='12 12 12 12'>
						<label>{nome} <i class={registro && parseFloat(registro.valor || 0) > 0.0  ? `fas fa-check-double` : 'fas fa-exclamation-triangle'} style={{ color: registro && parseFloat(registro.valor || 0) > 0.0 ? '#00a13b' : '#ff0000' }}></i></label>
					</Grid>
					<Grid cols='12 12 12 12'>
						<p>{registro ? FormatUtils.formatarValorTela(registro.valor, casasDecimais) : FormatUtils.formatarValorTela(0, casasDecimais)}</p>
					</Grid>
				</Row>
			</Grid>
		);
	}

	componenteNumericoAlteracao(nome, registro, evento, casasDecimais) {

		return (
			<Grid cols='12 12 12 12'>
				<Row style={{ paddingBottom: 8 }}>
					<Grid cols='12 12 12 12'>
						<label>{nome} <i class={registro && parseFloat(registro.valor || 0) > 0.0  ? `fas fa-check-double` : 'fas fa-exclamation-triangle'} style={{ color: registro && parseFloat(registro.valor || 0) > 0.0 ? '#00a13b' : '#ff0000' }}></i></label>
					</Grid>
					<button 
						type='button'
						class='btn btn-block btn-outline-dark btn-flat'
						style={{ maxWidth: 200 }}
						onClick={() => {
							this.setState({
								...this.state,
								casasComponenteNumerico: casasDecimais || 0,
								valorComponenteNumerico: registro ? FormatUtils.formatarValorTela(registro.valor, casasDecimais) : '',
								eventoComponenteNumerico: (result) => {
									evento(result);
									this.setState({
										...this.state,
										eventoComponenteNumerico: null
									});
								}
							});
						}}>
						{registro ? FormatUtils.formatarValorTela(registro.valor, casasDecimais) : FormatUtils.formatarValorTela(0, casasDecimais)}
					</button>
				</Row>
			</Grid>
		);
	}

	eventoComponenteNumerico() {
		if (!this.state.eventoComponenteNumerico) {
			return null;
		}

		return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-md'>
					<div class='modal-content'>
						<div class='modal-header'>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' 
								onClick={() => {
									this.setState({
										...this.state,
										eventoComponenteNumerico: null
									});
								}}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body'>
							<Row>
								<LabelAndInputNumber
									label='Informe' 
									placeholder='Informe'
									cols='12 12 12 12'
									casas={this.state.casasComponenteNumerico}
									value={this.state.valorComponenteNumerico}
									onChange={data => {
										this.setState({
											valorComponenteNumerico: data.target.value
										});
									}} />
							</Row>
						</div>
						<div class='modal-footer justify-content-between'>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
							<button type='button' class='btn btn-primary'
								onClick={() => {
									this.state.eventoComponenteNumerico(
										parseFloat(FormatUtils.formatarValorBanco(this.state.valorComponenteNumerico, this.state.casasComponenteNumerico))
									);
								}}>Salvar</button>
						</div>
					</div>
				</div>
			</div>
        );
	}

	
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.transferencia.aguardando,
	modoTela: state.transferencia.modoTela
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	alterarCargaBase, alterarDescargaBase	
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(TransferenciaBaseVisualizacao);
